import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
export default class MitigationApprovedCell extends React.Component {
  localizedData = [
    { text: "Yes", value: true },
    { text: "No", value: false },
  ];
  componentDidMount = () => {
    if (
      this.props.dataItem.inEdit &&
      document.getElementById("mitigationapprovedid")
    ) {
      document.getElementById("mitigationapprovedid").focus();
    }
  };
  handleChange = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.value,
    });
  };

  handleEditCell = () => {
    if (this.props.dataItem.isOpen === "Open" || this.props.dataItem.isOpen===true) {
      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };

  render() {
    const { dataItem, field } = this.props;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    if (field && dataItem.inEdit === field) {
      return (
        <DropDownList
          style={{ width: "100px" }}
          onChange={this.handleChange}
          value={this.localizedData.find((c) => c.value === dataValue)}
          data={this.localizedData}
          textField="text"
          id="mitigationapprovedid"
          disabled={this.props.dataItem.isOpen === "Closed" ? true : false}
        />
      );
    }
    if (dataItem.inEdit !== field) {
      return this.props.dataItem.role == "Standard User" ||
        this.props.dataItem.role == "View Only" ||
        this.props.dataItem.isOpen == false ? (
        <td>
          {dataValue.toString() === "true" || dataValue.toString() === "Yes"
            ? "Yes"
            : "No"}
        </td>
      ) : (
        <td onClick={this.handleEditCell}>
          {dataValue.toString() == "true" || dataValue.toString() === "Yes"
            ? "Yes"
            : "No"}
        </td>
      );
    }
  }
}
